// extracted by mini-css-extract-plugin
module.exports = {"richtext":"richtext_richtext__uBHgy"};